export const INIT_COLLECTION = 'INIT_COLLECTION'
export const ADD_COLLECTION = 'ADD_COLLECTION'
export const REMOVE_COLLECTION = 'REMOVE_COLLECTION'

export const INIT_CUSTOM_COLLECTION = 'INIT_CUSTOM_COLLECTION'
export const ADD_CUSTOM_COLLECTION = 'ADD_CUSTOM_COLLECTION'
export const REMOVE_CUSTOM_COLLECTION = 'REMOVE_CUSTOM_COLLECTION'
